import React, { useState, useEffect } from 'react';
import '../catalogue/styles.css';
import pptxgen from 'pptxgenjs';
import { saveAs } from 'file-saver';
import ExcelJS from 'exceljs';
import {
    Button,
    Form,
    Stack,
    Breadcrumb,
    Divider,
    ButtonGroup,
    Panel,
    Container,
} from 'rsuite';
import { mockUsers } from '@/data/mock';
import { useLocation } from 'react-router-dom';
import * as XLSX from 'xlsx';





const defaultData = mockUsers(10);

// const CustomButtonGroup = () => (
//     <ButtonGroup style={{ marginTop: 20, width: 700, gap: 20, marginBottom: 20 }} justified>
//         <Button appearance='ghost' color='cyan'><CSVLink data={defaultData} onClick={()=>{}}>Download Excel</CSVLink></Button>
//         <Button appearance='primary' color='cyan'>Downlaod PPT</Button>
//         <Button appearance='default' active>Copy Catalogue Link</Button>
//     </ButtonGroup>
// );

const Generate = () => {

  const ip = 'http://192.168.1.23:1337';
    

    const [cata, setCata] = useState([])
    const location = useLocation();
    useEffect(() => {
      const queryParams = new URLSearchParams(location.search);
      const encodedData = queryParams.get('data');
      if (encodedData == null) {
      } else {
        const decodedData = decodeURIComponent(encodedData);
        const parsedData: any[] = JSON.parse(decodedData);
  
        setCata(parsedData);
      }
    }, [location.search]);
  console.log(cata)
  const csvData = cata.map((item) => {
    const { id, attributes } = item;
    const { MaterialCollection, ProductionDetail, MultipleImage, CoverImage, Packaging, ...restAttributes } = attributes;
    const imageUrl = `${ip}${attributes.CoverImage?.data?.attributes?.url || ''}`;
    return {
      id,
      Image: imageUrl,
      ...restAttributes,
    };
  });
    
    
    const handleDownloadPPT = () => {
      const ppt = new pptxgen();
    
      // Helper function to add a slide with the product image and attributes
      const addProductSlide = (product) => {
        const slide = ppt.addSlide();
    
        // Add the product image from the nested "CoverImage" attribute
        const imageUrl = `${ip}${product.attributes.CoverImage.data.attributes.url}`;
        const imageOptions = {
          x: 1,
          y: 1,
          w: 3, // Adjust the width of the image as needed
          h: 3, // Adjust the height of the image as needed
        };
        slide.addImage({ path: imageUrl, ...imageOptions });
    
        // Add the product attributes as a table
        const tableRows = [];
        for (const [key, value] of Object.entries(product.attributes)) {
          // Exclude attributes you don't want to show in PPT
          if (['MaterialCollection', 'ProductionDetail', 'MultipleImage', 'CoverImage', 'Packaging'].includes(key)) {
            continue;
          }
    
          const attrCell = { text: key, options: { fontSize: 10, fontFace: 'Arial', color: '#000000', fill: '#74c5c0' } };
          const valCell = { text: value?.toString() || '', options: { fontSize: 8, fontFace: 'Arial', color: '#000000', fill: '#b9dcd8' } };
          tableRows.push([attrCell, valCell]);
        }
    
        const tableOptions = {
          x: 5,
          y: 0.4,
          w: '40%', // Adjust the width of the table as needed
          h: 5, // Adjust the height of the table as needed
          border: {
            pt: 2, // Border width in points
            color: '#ffffff', // Border color for the table
          },
          fontSize: 12, // Adjust the font size as needed
          fontFace: 'Arial', // Set the font face
          autoPage: true, // Enable automatic paging if the table exceeds slide size
        };
    
        slide.addTable(tableRows, tableOptions);
      };
    
      // Loop through each item in cata and add a slide for each product
      cata.forEach((item) => {
        addProductSlide(item);
      });
    
      // Download the PPT file
      ppt.writeFile('Catalogue.pptx');
    };
    

    const downloadExcelData = (data) => {
      const worksheet = XLSX.utils.json_to_sheet(data, {
        header: Object.keys(data[0]),
        skipHeader: false,
        cellDates: true,
      });
  
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
  
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const excelData = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
      saveAs(excelData, 'data.xlsx');
    };
    

    return (
        <>
            <Container className='main table-toolbar'>
                <Stack className="table-toolbar" justifyContent="space-between">
                    <Stack direction='column' alignItems='flex-start' >
                        <h3 className="title">Generate Link</h3>
                        <Breadcrumb>
                            <Breadcrumb.Item href="/dashboard">Home</Breadcrumb.Item>
                            <Breadcrumb.Item active>Generate Catalogue Link</Breadcrumb.Item>
                        </Breadcrumb>
                    </Stack>
                </Stack >
                <Divider className='divide' />
                <Stack direction='column' alignItems='center' spacing={5}>
                    <img src={''} style={{ width: 250, opacity: 0.3 }} />
                    <Form.ControlLabel><b>Copy the link below and share it with the buyer on email </b></Form.ControlLabel>
                    <Form.ControlLabel>We will update you whenever the buyer opens the catalogue link, shortlists, products or share any queries</Form.ControlLabel>
                    <Panel bordered><a>This feild contains Catalogue link</a></Panel>
                    <ButtonGroup style={{ marginTop: 20, width: 700, gap: 20, marginBottom: 20 }} justified>
                        <Button appearance='ghost' color='cyan' style={{padding:0}} onClick={() => downloadExcelData(csvData)} >Download Excel</Button>
                        <Button appearance='primary' color='cyan' onClick={handleDownloadPPT}>Downlaod PPT</Button>
                        <Button appearance='default' active>Copy Catalogue Link</Button>
                    </ButtonGroup>
                    {/* <CustomButtonGroup /> */}
                </Stack>
            </Container>
        </>
    );
};

export default Generate;